import { css, keyframes } from 'react-emotion';
import { getRgbaColor } from '../../utils/color';

const animateLoading = keyframes`
  50% {
    background-position: 100% 100%;
  }
`;

export const styles = props => ({
  popup: css({
    backgroundColor: getRgbaColor(props.backdropColor, props.backdropOpacity),
    color: '#fff',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    zIndex: props.zIndex,
    '& > div': {
      width: '100%',
      height: '100%'
    }
  }),
  close: css({
    position: 'absolute',
    top: 5,
    right: 5,
    zIndex: 1,
    '& svg path': {
      fill: getRgbaColor(props.buttonColor),
      stroke: getRgbaColor(props.buttonIconColor),
      strokeWidth: '0.5px'
    }
  }),
  zoomWrap: css({
    width: '100%',
    height: '100%',
    '&, & > div, & img': {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      margin: 'auto'
    },
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      width: 'auto',
      height: 'auto',
      zIndex: 0
    },
    '&.loading > .zoom-image img': {
      padding: '2px 0',
      background: `linear-gradient(to right, ${props.buttonColor}, ${props.buttonIconColor})`,
      backgroundSize: '200% 2px',
      backgroundPosition: '0 100%',
      backgroundRepeat: 'no-repeat',
      animation: `${animateLoading} 1s ease infinite`
    },
    '& > .multi-zoom-image': {
      opacity: 0
    },
    '&.hi-res > .zoom-image': {
      opacity: 0
    },
    '&.hi-res > .multi-zoom-image': {
      opacity: 1
    }
  })
});
